module.exports = __webpack_public_path__ + "img/googleSheets.fb6084ff.svg";